import { PageHead } from "@/components/utils";
import { FadeUp } from "@/components/Reveal";
import { GALLERY } from "@/lib/data";

export default function Gallery() {
  return (
    <>
      <PageHead
        title="Gallery — Good Looks Unisex Salon, Mansa"
        description="A visual look inside Good Looks Salon: hair, skin, bridal and studio moments."
      />
      <section className="bg-[#F3EAD9] pt-40 pb-16">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <FadeUp>
            <p className="eyebrow text-[#C89B3C] mb-6">— Gallery</p>
            <h1 className="font-display text-5xl md:text-8xl leading-[0.95]">
              Looks made<br /><span className="italic">in-house.</span>
            </h1>
            <p className="mt-6 max-w-xl text-black/60 text-sm italic">
              Placeholder imagery — will be replaced with in-salon photography.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-[#F3EAD9] pb-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {GALLERY.map((src, i) => {
              const tall = i % 5 === 1;
              return (
                <FadeUp key={i} delay={(i % 4) * 0.05} className={tall ? "row-span-2" : ""}>
                  <div className={`overflow-hidden bg-black/5 ${tall ? "aspect-[3/5]" : "aspect-[4/5]"}`}>
                    <img
                      src={src}
                      alt={`Salon work ${i + 1}`}
                      loading="lazy"
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1400ms]"
                    />
                  </div>
                </FadeUp>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
